"use client";

import React, { useEffect, useRef } from "react";

export function ContactHeroBackground() {
    const bgRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            if (!bgRef.current) return;
            const rect = bgRef.current.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            bgRef.current.style.setProperty("--mouse-x", `${x}px`);
            bgRef.current.style.setProperty("--mouse-y", `${y}px`);
        };

        window.addEventListener("mousemove", handleMouseMove);
        return () => window.removeEventListener("mousemove", handleMouseMove);
    }, []);

    return (
        <div
            ref={bgRef}
            className="absolute inset-0 z-0 overflow-hidden bg-black h-full pointer-events-none selection:bg-white/20"
            style={{
                ["--mouse-x" as any]: "50%",
                ["--mouse-y" as any]: "30%",
            }}
        >
            {/* Precision Blueprint Grid Layer */}
            <div
                className="absolute inset-0 opacity-20"
                style={{
                    contain: "paint",
                    backgroundImage: `
                        linear-gradient(to right, rgba(148, 163, 184, 0.25) 1px, transparent 1px),
                        linear-gradient(to bottom, rgba(148, 163, 184, 0.25) 1px, transparent 1px)
                    `,
                    backgroundSize: "60px 60px",
                }}
            />

            {/* Interactive Mouse-Following Radial Spotlight */}
            <div
                className="absolute inset-0 transition-opacity duration-500 opacity-60"
                style={{
                    background: `radial-gradient(650px circle at var(--mouse-x) var(--mouse-y), rgba(99, 102, 241, 0.12), rgba(6, 182, 212, 0.06) 40%, transparent 80%)`,
                }}
            />

            {/* Ambient High-End Architectural Glows */}
            <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-indigo-600/10 rounded-full blur-[140px] pointer-events-none" />
            <div className="absolute bottom-1/3 right-1/4 w-[600px] h-[600px] bg-cyan-600/10 rounded-full blur-[160px] pointer-events-none" />

            {/* Vignette to focus attention on form content */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_30%,black_95%)] pointer-events-none" />

            {/* Smooth bottom gradient transition */}
            <div className="absolute bottom-0 left-0 right-0 h-64 bg-linear-to-t from-black to-transparent pointer-events-none" />
        </div>
    );
}
